import request from '@host-panel/request';

type Response = {
  [networkId: string]: {
    id: string;
    network_id: string;
    network_name: string;
    network_color: string;
    network_image_id: string;
    v2: boolean;
  };
};

export function networkVersion(
  networkId: string,
  // If no spot_id was provided we are sending a spot_id related to the spotim network
  spotId: string = process.env.NODE_ENV !== 'production' ? 'sp_JRGmW7Ab' : 'sp_3VxIkgJh',
  shouldSetResponseTokenHeaders = true
): Promise<Response> {
  return request(`/host-panel/auth/version/network`, {
    method: 'GET',
    headers: {
      'x-spot-id': spotId,
      'x-spotim-networkid': networkId,
      'x-auth-version': '1'
    },
    shouldRetry: false,
    shouldSetResponseTokenHeaders
  });
}
